import React from 'react';
import { FaLock, FaCheckCircle } from 'react-icons/fa';

const SecurityNotice: React.FC = () => {
    return (
        <section className="w-full px-4 sm:px-6 py-10 md:py-16 bg-[#EFFFFD]">
            <div className="max-w-7xl mx-auto">
                <div className="relative overflow-hidden rounded-3xl p-6 sm:p-8 md:p-12 shadow-lg border-2 border-[#21A6B5] bg-white">
                    <div className="absolute top-0 right-0 -mr-20 -mt-20 w-60 h-60 md:w-80 md:h-80 bg-[#21A6B5] opacity-5 rounded-full blur-3xl pointer-events-none" />

                    <div className="relative z-10 flex flex-col lg:flex-row gap-8 md:gap-12 items-start">
                        {/* Left Side: Header & Content */}
                        <div className="flex-1 space-y-6 md:space-y-8 w-full">
                            <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                                <div className="inline-flex p-3.5 md:p-5 bg-[#21A6B5]/10 rounded-2xl border border-[#21A6B5]/20 w-fit">
                                    <FaLock className="text-[#21A6B5] text-xl md:text-3xl" />
                                </div>
                                <div>
                                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-[#2C3E50] font-['Inter']">
                                        Security Notice
                                    </h2>
                                    <p className="text-xs md:text-sm font-semibold text-gray-600 mt-1 md:mt-2 font-['Inter']">
                                        Fraud Awareness 
                                    </p>
                                </div>
                            </div>

                            <p className="text-base sm:text-lg md:text-xl font-medium leading-relaxed text-gray-700 max-w-2xl font-['Inter']">
                                <span className="font-bold text-[#21A6B5]">Fraudsters</span> are impersonating our employees via phone calls, SMS &amp; social media to collect fraudulent payments.
                                Stay vigilant.
                            </p>

                            <ul className="space-y-3 md:space-y-4">
                                {[
                                    "Do not click unknown links or reply to suspicious messages",
                                    "Verify email IDs and domains before engaging",
                                    "Be cautious of calls claiming to be from us"
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-3 group">
                                        <FaCheckCircle className="text-[#21A6B5] mt-1 md:mt-1.5 shrink-0 group-hover:scale-110 transition-transform text-sm md:text-base" />
                                        <span className="text-sm sm:text-base font-medium leading-snug text-gray-700 group-hover:text-[#2C3E50] transition-colors font-['Inter']">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Right Side: Safe Payment Box */}
                        <div className="w-full lg:w-[380px] shrink-0">
                            <div className="p-6 sm:p-8 rounded-3xl border-2 border-[#21A6B5] bg-[#21A6B5]/5 relative overflow-hidden h-full">
                                <div className="flex items-center gap-3 mb-4">
                                    <FaLock className="text-[#21A6B5] text-sm md:text-base" />
                                    <h3 className="text-sm md:text-base font-bold text-[#21A6B5] uppercase tracking-wide font-['Inter']">
                                        Safe Payment
                                    </h3>
                                </div>
                                <p className="text-sm sm:text-base md:text-lg font-semibold mb-5 text-[#2C3E50] leading-snug font-['Inter']">
                                    Pay only through our official website or authorised links.
                                </p>
                                <div className="pt-5 border-t border-[#21A6B5]/20">
                                    <p className="text-sm md:text-base font-medium leading-relaxed text-gray-700 italic font-['Inter']" lang="hi">
                                        भुगतान केवल आधिकारिक वेबसाइट से करें। किसी अज्ञात लिंक पर भरोसा न करें।
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecurityNotice;
